import React from 'react';

import {ButtonPrimary} from '@homeaway/react-buttons';
import {LoadingOverlay} from '@homeaway/react-loading-overlay';

import {useComponent} from './hooks';

import './SearchSubmitButton.less';

function SearchSubmitButton() {
    const {
        className,
        label,
        disabled,
        loading,
        onClick
    } = useComponent();

    return (
        <ButtonPrimary
            className={className}
            type="submit"
            label={label}
            disabled={disabled}
            onClick={onClick}
        >
            <LoadingOverlay loading={loading}/>
        </ButtonPrimary>
    );
}

export {SearchSubmitButton};
